import { useCallback } from 'react';
import { FaTwitter } from 'react-icons/fa';
import useCRM from './useCRM';

const useDisplayNames = () => {
  const crm = useCRM();

  const displayName = useCallback(
    (account) => {
      const wallet = crm[account];

      if (wallet?.twitter) {
        return (
          <a
            href={`https://twitter.com/${wallet?.twitter}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            {wallet?.twitter} <FaTwitter />
          </a>
        );
      } else {
        return wallet?.discord || wallet?.ethName || account;
      }
    },
    [crm]
  );

  return displayName;
};

export default useDisplayNames;
